import React from 'react';

export const SvgLanguageSwitch = (props) => (
  <svg
    overflow='hidden'
    viewBox='0 0 655 655'
    xmlns='http://www.w3.org/2000/svg'
    width='100%'
    height='100%'
    {...props}
  >
    <defs>
      <clipPath id='LanguageSwitch_svg__a'>
        <path d='M1441 743h730v726h-730z' />
      </clipPath>
    </defs>
    <g
      transform='translate(-1481.9 -783.5) scale(1.0006)'
      clipPath='url(#LanguageSwitch_svg__a)'
    >
      <path
        d='M1483.3 893.63c0-59.832 48.5-108.34 108.34-108.34h433.32c59.84 0 108.34 48.504 108.34 108.34v433.33c0 59.83-48.5 108.33-108.34 108.33h-433.32c-59.84 0-108.34-48.5-108.34-108.33z'
        fillRule='evenodd'
        stroke='#00b0f0'
        strokeMiterlimit={8}
        strokeWidth={4.583}
      />
      <path
        d='M1827.8 910.79h103.11c43.02 0 77.89 41.183 77.89 91.986v87.014h-181z'
        fill='none'
        stroke='#fff'
        strokeLinejoin='round'
        strokeMiterlimit={10}
        strokeWidth={50.417}
      />
      <path
        stroke='#fff'
        strokeLinejoin='round'
        strokeMiterlimit={10}
        strokeWidth={22.917}
        d='M1539.3 836.29h325v325h-325z'
      />
      <path
        d='M1739.2 1047.5h-62.484l-8.598 29.305h-56.066l66.723-177.52h59.82l66.723 177.52h-57.398zm-11.504-38.387-19.617-63.816-19.496 63.816z'
        style={{
          fill: '#fff'
        }}
        aria-label='A'
      />
      <path
        stroke='#fff'
        strokeLinejoin='round'
        strokeMiterlimit={10}
        strokeWidth={22.917}
        d='M1759.3 1053.3h325v325h-325z'
      />
      <path
        d='M1818.8 1269.9q7.75-41.656 60.062-69.75 0-5.813 1.937-21.312-20.344 1.938-35.844 1.938l-1.937-31.97q31 0 41.656-.968 1.937-11.625 7.75-37.781l36.812 6.78q-5.813 17.439-8.719 28.095 35.844-3.875 59.094-8.719l4.844 32.938q-33.906 6.781-68.781 8.719l-.969 11.625q25.188-1.938 37.781-.969 21.312 1.938 35.844 10.656 20.344 11.625 27.125 32.938 8.719 25.188-2.906 47.47-19.375 36.811-72.656 42.624l-13.562-28.094q17.438-2.906 28.094-6.781 18.406-6.781 25.188-20.344 6.781-13.562 1.937-26.156-3.875-12.594-16.469-18.406-22.28 37.78-45.53 56.188l2.906 9.687-32.938 17.438-.97-2.906q-21.311 12.594-40.687 11.625-15.5-.969-24.22-16.469-7.75-13.562-4.843-28.094zm45.531 11.625q10.656-1.938 18.406-9.688-1.938-6.78-2.906-17.437 0-9.688-.969-19.376-25.188 19.376-26.156 36.813-.969 11.624 11.625 9.687zm49.406-63.938q0 15.5.969 22.281 7.75-7.75 16.469-23.25-11.625 0-17.438.969z'
        style={{
          fill: '#fff'
        }}
        aria-label='\u3042'
      />
      <g fillRule='evenodd'>
        <path d='M1503.8 1263.3c0-82.57 66.26-149.5 148-149.5s148 66.93 148 149.5-66.26 149.5-148 149.5-148-66.93-148-149.5z' />
        <g
          stroke='#fff'
          strokeLinejoin='round'
          strokeMiterlimit={10}
          strokeWidth={11.458}
        >
          <path
            d='m1558.5 1195.3 24.53 5.52c21.44 3.02 45.02 4.69 69.77 4.69s48.33-1.67 69.77-4.69l24.53-5.52 15.81 23.46c6.05 14.3 9.39 30.03 9.39 46.54s-3.34 32.24-9.39 46.54l-15.81 23.46-24.53-5.52c-21.44-3.02-45.02-4.69-69.77-4.69s-48.33 1.67-69.77 4.69l-24.53 5.52-15.81-23.46c-6.05-14.3-9.39-30.03-9.39-46.54s3.34-32.24 9.39-46.54z'
            fill='none'
          />
          <path
            d='M1587.3 1263.8c0-66 29.33-119.5 65.5-119.5s65.5 53.5 65.5 119.5-29.33 119.5-65.5 119.5-65.5-53.5-65.5-119.5z'
            fill='none'
          />
          <path d='M1653.3 1145.3v239.12M1533.3 1265.3h238.78' fill='#4472c4' />
        </g>
      </g>
      <g fill='none' fillRule='evenodd'>
        <path
          d='M1533.3 1265.3c0-66.27 53.5-120 119.5-120s119.5 53.73 119.5 120-53.5 120-119.5 120-119.5-53.73-119.5-120z'
          stroke='#fff'
          strokeLinejoin='round'
          strokeMiterlimit={10}
          strokeWidth={11.458}
        />
        <path
          d='M1879.8 882.79v53.854M2035.2 1037.8h-54.427'
          stroke='#000'
          strokeMiterlimit={8}
          strokeWidth={8.021}
        />
      </g>
    </g>
  </svg>
);
